module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-2-ff668d5ea52c0bc8de36cf20a888d501.jpg";